import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components';
import { TranslationNamespace } from 'i18n';

// The receipt uploader chunk could not be loaded (useOrderReceipts gave up retrying). Usually the tab
// outlived a deploy and its chunks are gone, so the only way out is a reload.
type Props = {
  // For layouts that put the reload button elsewhere (the SQ footer).
  hideAction?: boolean;
};

export const ReceiptUploaderError: React.FC<Props> = ({ hideAction }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components',
  });

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-text-center">
      <span className="tw-text-md tw-text-primary">
        {t('error_fallback.title')}
      </span>
      {!hideAction && (
        <Button
          className="tw-max-w-md"
          color="primary"
          onClick={() => window.location.reload()}
        >
          {t('upload_confirmation_receipt.reload')}
        </Button>
      )}
    </div>
  );
};
